/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

// console.log('Hello World from Webpacker')
//= require activestorage

// Application styles (migrated from Sprockets)
import "../stylesheets/application";

// Font Awesome 6 (required for EasyMDE icons)
import "@fortawesome/fontawesome-free/css/all.css";

// EasyMDE - Markdown Editor
import EasyMDE from "easymde";
import "easymde/dist/easymde.min.css";
import "../stylesheets/easymde_custom.css";

// Initialize EasyMDE on all markdown editor fields
document.addEventListener('DOMContentLoaded', () => {
  initializeMarkdownEditors();
});

// Also initialize on Turbolinks page load (if Turbolinks is used)
document.addEventListener('turbolinks:load', () => {
  initializeMarkdownEditors();
});

function initializeMarkdownEditors() {
  const editors = document.querySelectorAll('[data-markdown-editor="true"]');

  editors.forEach((textarea) => {
    // Prevent double initialization
    if (textarea.dataset.mdeInitialized === 'true') {
      return;
    }

    // Get custom options from data attribute or use defaults
    const customOptions = textarea.dataset.markdownOptions
      ? JSON.parse(textarea.dataset.markdownOptions)
      : {};

    const defaultOptions = {
      element: textarea,
      spellChecker: false,
      status: false,
      toolbar: [
        'bold', 'italic', 'heading', 'heading-smaller', 'heading-bigger', '|',
        'quote', 'unordered-list', 'ordered-list', '|',
        'link',  '|',
        'preview', 'side-by-side', 'fullscreen', '|',
        'guide'
      ]
    };

    new EasyMDE({ ...defaultOptions, ...customOptions });
    textarea.dataset.mdeInitialized = 'true';
  });
}